<template>
  <div>
    <h2 class="title">General info</h2>
    <general-info-form
      :initial-values="form"
      :vs="vs"
      :categories="categories"
      @values="form = $event"
    />
    <div>
      <h2 class="title additional-title">Additional info</h2>
      <p class="description">
        This information is optional. If you decide to skip it, you can edit at any moment under
        your event settings.
      </p>
    </div>
    <cover-field
      id="event-cover-field"
      v-model="form.cover"
      @upload-in-progress="uploadInProgress = $event"
    />
    <v-layout class="pb-16">
      <v-flex class="pr-30" xs12>
        <text-field
          v-model.trim="form.metadata.facebookLink"
          :validator="vs.metadata.facebookLink"
          label="Facebook link"
        />
      </v-flex>
      <v-flex xs12>
        <text-field
          v-model.trim="form.metadata.webLink"
          :validator="vs.metadata.webLink"
          label="Website"
        />
      </v-flex>
    </v-layout>
    <text-editor-field
      v-model="form.description"
      placeholder="Description"
      :validator="vs.description"
      image-and-code-block-enabled
    />
    <p class="text-field-description">Description will be visible on the event page</p>
    <h2 class="title">Highlighted information (optional)</h2>
    <p class="description">
      Add useful information about your event (like age limit, table reservation, etc.)
    </p>
    <highlights-form :initial-values="form" :vs="vs" @values="form = $event" />
    <h2 class="title">Frequently Asked Questions (optional)</h2>
    <p class="description">
      Add frequently asked questions about your event. This will be displayed on the landing page of
      your event.
    </p>
    <faq-form :initial-values="form" :vs="vs" @values="form = $event" />
    <div v-if="showButtons" class="buttons-wrapper">
      <main-button class="back-btn" flat :text="'CANCEL'" @click="goBack()" />
      <div class="buttons">
        <main-button
          class="continue-btn"
          depressed
          color="#0277BD"
          flat
          :outline="true"
          @click="() => this.$emit('back')"
        >
          <v-icon class="arrow-back">arrow_back</v-icon>
          <span>back</span>
        </main-button>
        <main-button
          :disabled="uploadInProgress || !isFormValid"
          class="continue-btn"
          depressed
          @click="() => this.$emit('next')"
        >
          <span>continue</span>
          <v-icon class="arrow">arrow_forward</v-icon>
        </main-button>
      </div>
    </div>
  </div>
</template>

<script>
import FaqForm from './faq-form.vue'
import GeneralInfoForm from './general-info-form.vue'
import HighlightsForm from './highlights-form.vue'

export default {
  name: 'event-info-form',
  components: {
    GeneralInfoForm,
    HighlightsForm,
    FaqForm,
  },
  props: {
    initialValues: {
      type: Object,
      default: () => {
      },
    },
    categories: {
      type: Array,
      default: () => [],
    },
    vs: {
      type: Object,
      default: () => {
      },
    },
    showButtons: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      form: this.initialValues,
      uploadInProgress: false,
    }
  },
  computed: {
    isFormValid() {
      return !this.vs.$invalid && !this.vs.$error
    },
  },
  watch: {
    form: {
      handler(val) {
        this.$emit('values', val)
      },
      deep: true,
    },
  },
  async mounted() {
    const targetId = window.location.hash
    if (targetId) {
      await this.$nextTick()
      this.scrollToElement(targetId)
    }
  },
  methods: {
    scrollToElement(id) {
      const target = document.querySelector(id)
      if (target) {
        target.scrollIntoView({ behavior: 'smooth', block: 'center' })
      }
    },
  },
}
</script>

<style>
.mln-32 {
  margin-left: -2rem !important;
}

.title {
  font-family: 'Raleway';
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  letter-spacing: -0.03em;
  font-feature-settings: 'pnum' on, 'lnum' on;
  color: #ff4c00;
  margin-bottom: 1.5rem;
}

.additional-title {
  font-family: 'Raleway';
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  letter-spacing: -0.03em;
  font-feature-settings: 'pnum' on, 'lnum' on;
  color: #ff4c00;
  margin-bottom: 1.5rem;
  margin-top: 1.5rem;
}

.description {
  font-family: 'Source Sans Pro';
  font-style: normal;
  font-weight: 400;
  font-size: 1.125rem;
  color: #979797;
  margin-bottom: 1.5rem;
}

.buttons-wrapper {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

@media screen and (max-width: 444px) {
  .buttons-wrapper {
    flex-direction: column-reverse;
  }

  .buttons {
    display: flex;
    flex-direction: column-reverse;
  }
}

.text-field-description {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 0.75rem;
  line-height: 1rem;
  color: #666666;
  margin-bottom: 1.5rem;
  margin-top: -1.875rem;
  margin-left: 0.875rem;
}

.arrow {
  margin-left: 0.625rem;
}

.arrow-back {
  margin-right: 0.625rem;
}

.textFieldDescription {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 0.75rem;
  line-height: 1rem;
  color: #666666;
  margin-bottom: 1.5rem;
  margin-top: -0.875rem;
  margin-left: 0.875rem;
}
</style>
